import { Input } from '@trackman/web-shared-components';
import React, { useState } from 'react';
import {
  centimetersToInches,
  inchesToCentimeters,
  parseNumericInput,
  sanitizeNumericInput,
} from 'services/helper-services/strikeZonePlanes';
import { DualUnitWrapper, EqualsSign } from './StrikeZoneCalculationStyles';

interface IProps {
  label: string;
  valueInInches: number;
  onChange: (valueInInches: number) => void;
  testIdPrefix: string;
}

type EditedField = 'inches' | 'centimeters' | null;

export const DualUnitInput: React.FC<IProps> = (props) => {
  const { label, valueInInches, onChange, testIdPrefix } = props;
  const [editedField, setEditedField] = useState<EditedField>(null);
  const [rawValue, setRawValue] = useState('');

  const inchesValue = editedField === 'inches' ? rawValue : String(valueInInches);
  const centimetersValue = editedField === 'centimeters' ? rawValue : String(inchesToCentimeters(valueInInches));

  const handleChange = (field: Exclude<EditedField, null>) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const raw = sanitizeNumericInput(event.target.value);
    setEditedField(field);
    setRawValue(raw);

    const parsed = parseNumericInput(raw);

    if (parsed === null) {
      return;
    }

    onChange(field === 'inches' ? parsed : centimetersToInches(parsed));
  };

  const handleBlur = () => {
    setEditedField(null);
    setRawValue('');
  };

  return (
    <DualUnitWrapper>
      <Input
        label={label}
        value={inchesValue}
        width={140}
        onChange={handleChange('inches')}
        onBlur={handleBlur}
        inputProps={{ inputMode: 'decimal' }}
        data-testid={`${testIdPrefix}-input-in`}
      />
      <Input label='Unit' value='in' width={54} inputProps={{ readOnly: true }} />
      <EqualsSign>=</EqualsSign>
      <Input
        label={label}
        value={centimetersValue}
        width={140}
        onChange={handleChange('centimeters')}
        onBlur={handleBlur}
        inputProps={{ inputMode: 'decimal' }}
        data-testid={`${testIdPrefix}-input-cm`}
      />
      <Input label='Unit' value='cm' width={54} inputProps={{ readOnly: true }} />
    </DualUnitWrapper>
  );
};
